import { useEffect, useState } from 'react';
import { Member_LoginType } from '@trello/graphql/generated';
import { useAtlassianAccountMigrationStageQuery } from './AtlassianAccountMigrationStageQuery.generated';

import { HYGIENE_MESSAGE_ID } from 'app/src/components/EmailHygieneWizard';
import { AtlassianAccountMigrationStage as Stage } from './types';

interface Options {
  skip?: boolean;
}

export function useAtlassianAccountMigrationStage({
  skip = false,
}: Options = {}) {
  const [stage, setStage] = useState<Stage | null>(null);
  const { data, refetch } = useAtlassianAccountMigrationStageQuery({
    skip,
    variables: { memberId: 'me' },
  });
  const me = data?.member;

  useEffect(() => {
    if (!me) {
      return;
    }
    if (me.isAaMastered) {
      if (!me.loginTypes?.includes(Member_LoginType.Atlassian)) {
        setStage(Stage.onboarding);
      } else if (
        me.domainClaimed &&
        !me.oneTimeMessagesDismissed?.includes('newly-managed')
      ) {
        setStage(Stage.newlyManaged);
      } else {
        setStage(Stage.done);
      }
    } else if (me.aaEnrolledDate) {
      // Temporary: normally this should be folded into the next state.
      // There are 3 holdout organizations that have not been automatically
      // onboarded yet; when they are done, we can delete this stage.
      setStage(Stage.legacyOnboardingV2);
    } else if (me.idEnterprise) {
      setStage(Stage.ineligible);
    } else if (me.oneTimeMessagesDismissed?.includes(HYGIENE_MESSAGE_ID)) {
      setStage(Stage.migration);
    } else if (me.confirmed) {
      setStage(Stage.emailHygiene);
    } else {
      setStage(Stage.confirmEmail);
    }
  }, [me]);

  return { stage, me, refetchStage: refetch };
}
